import "core-js/modules/es6.object.assign";
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useRef } from 'react';
import { forwardRef, Box, PopoverBase } from '@landr/maestro';
import { defaultNumberOfStreams, maximumNumberOfStreams } from '../../../../constants/streams.es.js';
import { useSlider } from './useSlider.es.js';
import { useDrag } from './useDrag.es.js';
import { Root, Rail, Draggable, Handle } from './styled.es.js';
import { useRoyaltyCalculatorContext } from '../../../../contexts/RoyaltyCalculatorProvider/RoyaltyCalculatorContext.es.js';
var _excluded = ["value", "position", "radius", "onChange", "onChangeEnd", "minPosition", "maxPosition", "defaultPosition", "isDisabled"],
    _excluded2 = ["width", "onChange", "onChangeEnd", "min", "max", "handleRadius", "isDisabled", "defaultValue", "value"]; // TODO: update Slider component and use Maestro Slider https://mixgenius.atlassian.net/browse/DS-1631

var DragHandle = function DragHandle(_ref) {
  var value = _ref.value,
      position = _ref.position,
      radius = _ref.radius,
      onChange = _ref.onChange;
  _ref.onChangeEnd;

  var minPosition = _ref.minPosition,
      maxPosition = _ref.maxPosition,
      defaultPosition = _ref.defaultPosition,
      isDisabled = _ref.isDisabled,
      props = _objectWithoutProperties(_ref, _excluded);

  var handleValueChange = function handleValueChange() {
    setNumberOfStreams((value === null || value === void 0 ? void 0 : value.min) || defaultNumberOfStreams);
  };

  var _useDrag = useDrag({
    value: value,
    position: position,
    minPosition: minPosition,
    maxPosition: maxPosition,
    defaultPosition: defaultPosition,
    onChange: onChange,
    onChangeEnd: handleValueChange,
    isDisabled: isDisabled
  }),
      currentPosition = _useDrag.currentPosition,
      isDragging = _useDrag.isDragging,
      handleMouseDown = _useDrag.handleMouseDown,
      handleTouchStart = _useDrag.handleTouchStart;

  var _useRoyaltyCalculator = useRoyaltyCalculatorContext(),
      setNumberOfStreams = _useRoyaltyCalculator.setNumberOfStreams;

  var handleRef = useRef(null);
  return (
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement(Draggable, Object.assign({
      onMouseDown: handleMouseDown,
      onTouchStart: handleTouchStart,
      radius: radius,
      position: currentPosition,
      isDragging: isDragging
    }, props, {
      ref: handleRef
    }),
    /*#__PURE__*/
    React.createElement(Handle, {
      radius: radius,
      isDisabled: isDisabled
    })),
    /*#__PURE__*/
    React.createElement(PopoverBase, {
      isOpen: true,
      triggerRef: handleRef,
      anchorRef: handleRef,
      placement: "top",
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        minWidth: 'auto',
        backgroundColor: '#152536'
      }
    },
    /*#__PURE__*/
    React.createElement("span", null, value === null || value === void 0 ? void 0 : value.min),
    /*#__PURE__*/
    React.createElement("span", null, "streams")))
  );
};

var Slider = forwardRef(function (props, ref) {
  var width = props.width;
  props.onChange;
  props.onChangeEnd;
  var min = props.min,
      max = props.max,
      _props$handleRadius = props.handleRadius,
      handleRadius = _props$handleRadius === void 0 ? 10 : _props$handleRadius,
      _props$isDisabled = props.isDisabled,
      isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled;
  props.defaultValue;
  props.value;

  var rest = _objectWithoutProperties(props, _excluded2);

  var _useSlider = useSlider(_objectSpread(_objectSpread({}, props), {}, {
    defaultValue: {
      min: defaultNumberOfStreams,
      max: maximumNumberOfStreams
    }
  })),
      currentValue = _useSlider.currentValue,
      positions = _useSlider.positions,
      minPosition = _useSlider.minPosition,
      maxPosition = _useSlider.maxPosition,
      updateMinFromPosition = _useSlider.updateMinFromPosition,
      onMinChangeEnd = _useSlider.onMinChangeEnd;

  return (
    /*#__PURE__*/
    React.createElement(Root, Object.assign({
      ref: ref,
      min: min,
      max: max,
      width: width
    }, rest),
    /*#__PURE__*/
    React.createElement(Box, {
      display: "flex",
      width: "100%"
    },
    /*#__PURE__*/
    React.createElement(Rail, {
      isDisabled: isDisabled
    }),
    /*#__PURE__*/
    React.createElement(DragHandle, {
      value: currentValue,
      position: positions.min,
      radius: handleRadius,
      onChange: updateMinFromPosition,
      onChangeEnd: onMinChangeEnd,
      minPosition: minPosition,
      maxPosition: maxPosition,
      defaultPosition: maxPosition / 2,
      isDisabled: isDisabled
    })))
  );
});
Slider.displayName = 'Slider';
export { Slider };